
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.53 50.538c0-6.84.1-13.69 0-20.53-.06-4.53-1.88-9.09-3.29-13.47.92-1 1.14-2.84 1.14-4 0-1.45-.37-4.13-2.1-4.53a.58.58 0 00-.19 0H17a.46.46 0 00-.33.15c-2.3 1.37-2.89 6.48-.82 8.36.235.197.502.353.79.46-1.2 4.28-2.64 8.64-2.64 13.05v20.66c0 .39.09 1.57.7 1.57h31.06a.23.23 0 00.28-.05c.29-.16.41-.67.46-1.08a3.257 3.257 0 000-.4l.03-.19zm-4.33-1.65l.21.2h-.35l.14-.2zm2.92-20.17a14.667 14.667 0 000 2.16v17.44l-2.14-2.05c.05-.53.08-1.14.08-1.86v-14.85c0-1.87-1.39-1.89-1.39 0v16.79l-2 2v-19.47l2.49-10.26 2.13 7.31c.25.86.61 1.86.83 2.79zm-2.85-14.81v-2.68a1.61 1.61 0 010 2.68zm-25.11-2.76h22.69a7.1 7.1 0 000 2.83H18.19a.641.641 0 00-.24 0H17.8a.509.509 0 01-.33 0h-.32c-1.03.03-1.01-.92.01-2.83zm-1.8 17.33c.178-.548.321-1.105.43-1.67.45-1.72.87-3.46 1.31-5.19.36-1.41.69-2.84 1.07-4.25a.45.45 0 000-.11c1.23.07 2.57-.13 3.5-.13h19.21l-2.56 10.52v.14c-.047.217-.07.438-.07.66v20.65H15.38v-14.52c.01-2-.17-4.1-.02-6.1z"}})])
          )
        }
      }
    